import { v2Request } from './client';

export const APP_UPDATE_DOC_ID = 'customer-app';

/**
 * Pilot app_updates metadata (Capgo OTA + optional native force-update rules).
 * @returns {Promise<{
 *   version: string,
 *   bundleUrl: string,
 *   releaseNotes?: string,
 *   releasedAt?: number,
 *   minNativeIosVersion?: string|null,
 *   minNativeIosBuild?: number|null,
 *   minNativeAndroidVersion?: string|null,
 *   minNativeAndroidBuild?: number|null,
 *   forceNativeUpdateMessage?: string|null,
 * } | null>}
 */
export async function getAppUpdateInfo() {
  const body = await v2Request(`/api/app-updates/${encodeURIComponent(APP_UPDATE_DOC_ID)}`);
  return body?.data ?? null;
}
